<template>
  <div class="clip-box-wrapper">
    <div class="clip-box">
      <slot></slot>
      <div class="left"></div>
      <div class="top-left"></div>
      <div class="top-right"></div>
      <div class="bottom-right"></div>
      <div class="bottom-left"></div>
      <div class="bottom-left-italics"></div>
    </div>
    <div class="line-bottom"></div>
    <div class="line-left"></div>
  </div>
</template>

<script>
  export default {
    name: "ClipBox",
  };
</script>

<style scoped lang="less">
  .clip-box-wrapper {
    position: relative;
    .clip-box {
      width: 100%;
      height: 100%;
      position: relative;
      box-sizing: border-box;
      padding-left: 2px;
      //background-color: #003F40;
      clip-path: polygon(
        16px 0,
        calc(100% - 13px) 0,
        100% 13px,
        100% calc(100% - 13px),
        calc(100% - 13px) 100%,
        66px 100%,
        54px calc(100% - 12px),
        3px calc(100% - 12px),
        3px 13px
      );
      border: 1px solid #00b2ff;

      .left {
        position: absolute;
        left: 1px;
        top: 10px;
        width: 2px;
        height: calc(100% - 13px);
        background-color: #00b2ff;
      }

      .top-left,
      .top-right,
      .bottom-right,
      .bottom-left-italics {
        position: absolute;
        width: 19px;
        height: 2px;
        background-color: #00b2ff;
      }

      .top-left {
        top: -3px;
        left: 3px;
        transform-origin: 100% 50%;
        transform: translateX(calc(-100% + 13px)) rotate(-45deg);
      }

      .top-right {
        top: -3px;
        right: 0;
        transform-origin: 0 50%;
        transform: translateX(calc(100% - 13px)) rotate(45deg);
      }

      .bottom-right {
        bottom: -3px;
        right: 0;
        transform-origin: 0 50%;
        transform: translateX(calc(100% - 13px)) rotate(-45deg);
      }

      .bottom-left {
        position: absolute;
        left: 2px;
        bottom: 11px;
        width: 50px;
        height: 1px;
        background-color: #00b2ff;
      }

      .bottom-left-italics {
        bottom: 11px;
        left: 52px;
        transform-origin: 0 50%;
        transform: rotate(45deg);
      }
    }

    .line-bottom {
      position: absolute;
      left: 0;
      bottom: calc(12px - 3px);
      width: 30px;
      height: 6px;
      background-color: #00b2ff;
    }
    .line-left {
      position: absolute;
      left: 0;
      bottom: calc(12px - 3px);
      height: 30px;
      width: 6px;
      background-color: #00b2ff;
    }
  }
</style>
